/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEshopFaqViewProps } from './eshop-faq';

export class EshopFaqView extends React.PureComponent<IEshopFaqViewProps> {
  public state: any = { hasMounted: false };

  public componentDidMount(): void {
    if (!this.state.hasMounted) {
      this.setState({ hasMounted: true });
    }

    setTimeout(() => {
      if (window.location.hash === '#contactus') {
        const map = document.getElementById('contactus');
        map?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 1000);

  }

  public render(): JSX.Element | null {
    if (!this.state.hasMounted) {
      return null;
    }

    const { faqDetails } = this.props

    return (
      <div className='eshop-faq'>
        <div className='eshop-faq__details'>
          {this._renderDetails()}
          <div className='eshop-faq__questions-section'>
            {this._renderReactFragment(faqDetails)}
          </div>
          {this._renderContactUs()}
        </div>
      </div>
    );
  }

  private _showChat() {
    const frame = document.querySelector(".purechat-launcher-frame") as HTMLIFrameElement;
    const btn = frame?.contentDocument?.querySelector(".purechat-launcher-message-wrapper") as HTMLElement;
    btn.click();
  }

  private _renderContactUs(): JSX.Element | null {
    const { config } = this.props;
    const ways = [
      {
        'icon': <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" className="bi bi-envelope" viewBox="0 0 16 16">
          <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
        </svg>,
        'title': config.emailUsHeader,
        'text': config.emailUsDescription,
        'link': <a href={`mailto:${config.emailUsEmail}`}>{config.emailUsEmail}</a>
      },
      {
        'icon': <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" className="bi bi-chat" viewBox="0 0 16 16">
          <path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z" />
        </svg>,
        'title': config.messageUsHeader,
        'text': config.messageUsDescription,
        'link': <a role='button' onClick={this._showChat}>{config.messageUsChat}</a>
      },
      {
        'icon': <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
        </svg>,
        'title': config.callUsHeader,
        'text': config.callUsDescription,
        'link': <a>{config.callUsPhone}</a>
      }];
    return (
      <div className='info' id='contactus'>
        <h1>{config.contactUsHeader}</h1>
        <p className='information'>{config.contactUsDescription}</p><br />
        <div className='row mx-md-n3'>
          {ways.map(w =>
            <div className='col-md-4 col-lg-4 px-md-3'>
              <div className='contact-us-ways'>
                <div className='contact-us-ways-icon'>{w.icon}</div>
                <h5>{w.title}</h5>
                <p className='contact-us-ways-text'>{w.text}</p>
                <p className='contact-us-ways-link'>{w.link}</p>
              </div>
            </div>)}
        </div><br />
      </div>
    );
  }

  private _renderDetails(): JSX.Element | null {
    const { config, information } = this.props;

    return (
      <div className='info'>
        <h1>{config.titleHeadingTag}</h1>
        <p className='information' id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>{information}</p>
      </div>
    );
  }

  private _renderReactFragment = (item: React.ReactNode): JSX.Element | null => {
    return (
      <>
        <React.Fragment>
          {item}
        </React.Fragment>
      </>
    );
  }
}

export default EshopFaqView;
